module.exports = __webpack_public_path__ + "img/plsx_white.0b3fde79.png";